const subAdminsApiRoutes = {
  subAdmins: '/api/v1/admin/sub-admin-list',
  createSubAdmins: '/api/v1/admin/create-sub-admin',
  subAdminEnabled: '/api/v1/admin/sub-admin-account-block',
}

export const subAdminsAPIRoutes = {
  ...subAdminsApiRoutes,
}
